import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, CheckCircle2, Phone } from "lucide-react";
import api from "../../lib/api";
import { AdminHeader, Btn, DataTable } from "../../components/admin/Fields";

const AdminCallbacksPage = () => {
  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState(null);
  const load = () => api.get("/admin/callback-requests").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (r) => {
    await api.put(`/admin/callback-requests/${r.id}`, { handled: !r.handled });
    load();
  };
  const remove = async (r) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/admin/callback-requests/${r.id}`);
    setSelected(null); load();
  };

  return (
    <div data-testid="admin-callbacks-page">
      <AdminHeader eyebrow="Inbox" title="Geri Arama Talepleri" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-7">
          <DataTable
            columns={[
              { key: "handled", label: "", render: (r) => <span className={`inline-block w-2 h-2 rounded-full ${r.handled ? "bg-brand-medium" : "bg-brand-gold"}`} /> },
              { key: "name", label: "Ad" },
              { key: "phone", label: "Telefon" },
              { key: "topic", label: "Konu" },
              { key: "created_at", label: "Tarih", render: (r) => (r.created_at || "").substring(0, 16).replace("T", " ") },
            ]}
            rows={rows}
            onRowClick={(r) => setSelected(r)}
          />
        </div>
        <div className="lg:col-span-5">
          {selected ? (
            <div className="bg-white border border-black/5 p-6 md:p-8 sticky top-6" data-testid="callback-detail">
              <div className="text-[0.66rem] tracking-[0.28em] uppercase text-brand-medium">{(selected.created_at || "").substring(0, 16).replace("T", " ")}</div>
              <div className="font-serif text-2xl text-brand-navy mt-2">{selected.name}</div>
              <a href={`tel:${selected.phone}`} className="mt-3 inline-flex items-center gap-2 text-brand-navy hover:text-brand-gold" data-testid="cb-detail-call">
                <Phone size={16} strokeWidth={1.5} className="text-brand-gold" /> {selected.phone}
              </a>
              {selected.topic ? <div className="mt-4 text-brand-dark">{selected.topic}</div> : null}
              <div className="mt-6 text-[0.66rem] tracking-[0.28em] uppercase text-brand-medium">Dil: {selected.lang || "tr"}</div>
              <div className="mt-8 flex gap-3">
                <Btn onClick={() => toggle(selected)}><CheckCircle2 size={14} /> {selected.handled ? "Okunmadı" : "İşlendi olarak işaretle"}</Btn>
                <Btn variant="danger" onClick={() => remove(selected)}><Trash2 size={14} /> Sil</Btn>
              </div>
            </div>
          ) : (
            <div className="bg-white border border-black/5 p-6 md:p-8 text-brand-medium">Bir talep seçin.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminCallbacksPage;
